import {
    useGetCompanyInfoSelector,
    useGetUserInfoSelector,
    useGetUserSelector,
} from 'core/redux/selectors/authSelectors';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router';

const useTagManager = () => {
    const client = useGetUserInfoSelector();
    const user = useGetUserSelector();
    const company = useGetCompanyInfoSelector();
    const location = useLocation();

    useEffect(() => {
        if (!client || !user) return;

        TagManager.dataLayer({
            dataLayer: {
                tool: 'CDM',
                page: location.pathname.replaceAll('/', '') || 'home',
                first_name: client.first_name,
                last_name: client.last_name,
                user: client.email,
                language: client.language,
                country: client.country.iso,
                client_id: company?.id,
                client_name: company?.name,
                is_superuser: user.as_user_is_superuser === 'true',
                original_user: user.original_user,
                user_id: client.id,
                env: import.meta.env.MODE,
                event: 'cdm',
            },
        });
    }, [client, location.pathname]);
};

export default useTagManager;
